export enum TermsAndConditionsMessages {
    DONE = 'Se han creado los Términos y Condiciones',
    GENERAL_ERROR_DEFAULT = 'Ocurrió un error creando los Términos y Condiciones',
    INVALID_VERSION = 'Ya hay una versión igual o superior',
    NO_FILE = 'No se ha subido un archivo',
    NO_TEXT = 'El texto de los términos y condiciones está vacío',
    NO_VERSION = 'No se ha indicado la versión'
}
